/** Navigation hints only: the authenticated API still authorizes every tenant/object. */
export const routeNames = ["home", "orders", "order", "return", "billing", "support", "admin_order", "admin_client", "admin_problem"] as const;
export type LaunchRoute = { route: typeof routeNames[number]; tenant: string; reference: string };
const part = /^[A-Za-z0-9_-]{1,120}$/;

export function parseStartParameter(raw: string): LaunchRoute {
  if (!/^v1_[A-Za-z0-9_-]{1,509}$/.test(raw)) throw new Error("Некорректная ссылка SCL");
  try {
    const value: unknown = JSON.parse(atob(raw.slice(3).replace(/-/g, "+").replace(/_/g, "/")));
    if (!Array.isArray(value) || value.length !== 3) throw new Error();
    const [route, tenant, reference] = value;
    if (!routeNames.includes(route) || typeof tenant !== "string" || !part.test(tenant)
      || typeof reference !== "string" || (reference !== "" && !part.test(reference))) throw new Error();
    if (["order", "return", "admin_order", "admin_problem"].includes(route) && !reference) throw new Error();
    return { route, tenant, reference };
  } catch {
    throw new Error("Некорректная ссылка SCL");
  }
}

export function readLaunchRoute(): { value: LaunchRoute | null; error: string } {
  const query = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const signed = new URLSearchParams(window.Telegram?.WebApp?.initData || hash.get("tgWebAppData") || "");
  const raw = query.get("scl_start") || signed.get("start_param") || query.get("tgWebAppStartParam") || hash.get("tgWebAppStartParam");
  if (!raw) return { value: null, error: "" };
  try { return { value: parseStartParameter(raw), error: "" }; }
  catch (error) { return { value: null, error: (error as Error).message }; }
}

export function encodeStartParameter(value: LaunchRoute): string {
  return "v1_" + btoa(JSON.stringify([value.route, value.tenant, value.reference])).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function adminDestination(value: LaunchRoute): string {
  // Keep Telegram's launch fragment on same-origin navigation; never put initData in a query.
  const fragment = new URLSearchParams(window.location.hash.slice(1));
  const launch = new URLSearchParams();
  for (const [key, item] of fragment) if (key.startsWith("tgWebApp")) launch.set(key, item);
  const initData = window.Telegram?.WebApp?.initData;
  if (initData) launch.set("tgWebAppData", initData);
  return `/admin?scl_start=${encodeStartParameter(value)}${launch.size ? `#${launch}` : ""}`;
}
